import { NgModule } from '@angular/core';

import { directives } from './';

@NgModule({
	imports: [],
	exports: [...directives],
	declarations: [...directives],
	providers: [],
})
export class ManifestDirectiveModule {}
